import type { UseFormReturn } from 'react-hook-form'

import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/modules/shared/components/ui/form'
import { Input } from '@/modules/shared/components/ui/input'

import type { FilterFormValues } from '../../hooks/use-filter-orders.hook'

type FilterFormCodeProps = {
	form: UseFormReturn<FilterFormValues>
	handlePressEnter: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

export function OrderFilterFormCodeComponent({
	form,
	handlePressEnter,
}: FilterFormCodeProps) {
	return (
		<FormField
			control={form.control}
			name="codigo"
			render={({ field }) => (
				<FormItem>
					<FormLabel htmlFor="cliente">Código</FormLabel>
					<FormControl>
						<Input
							onClick={(e) => {
								const inputElement = e.target as HTMLInputElement
								inputElement.select()
							}}
							id="codigo"
							placeholder="Código do pedido"
							{...field}
							onKeyUp={handlePressEnter}
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
